import { useEffect, useState } from 'react';

/**
 * Tracks whether the app is in dark mode by observing the `dark` class on
 * `<html>` — the single source of truth toggled by ThemeToggle. Lets non-CSS
 * consumers (e.g. the MUI theme) react to the same signal as Tailwind.
 */
export function useIsDarkMode(): boolean {
  const [isDark, setIsDark] = useState<boolean>(
    () => typeof document !== 'undefined' && document.documentElement.classList.contains('dark'),
  );

  useEffect(() => {
    const root = document.documentElement;
    const update = () => setIsDark(root.classList.contains('dark'));
    update();

    const observer = new MutationObserver(update);
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  return isDark;
}
